import AddEditApiAccessPopup from "./AddEditApiAccessPopup";

export default AddEditApiAccessPopup;